import { defineMessages } from "react-intl";

export default defineMessages({
  contactUsCaptcha: {
    id: "js_validate.contact_us_captcha",
    defaultMessage: "Please enter the correct captcha code.",
  },
  email: {
    id: "js_validate.email",
    defaultMessage: "Please enter a valid email address.",
  },
  firstname: {
    id: "js_validate.firstname",
    defaultMessage: "Please enter your first name.",
  },
  firstnameErrorAt: {
    id: "js_validate.firstname_error_at",
    defaultMessage: "Please enter your first name.",
  },
  name: {
    id: "js_validate.name",
    defaultMessage: "Please enter your name.",
  },
  nameErrorAt: {
    id: "js_validate.name_error_at",
    defaultMessage: "Please enter your name.",
  },
  number: {
    id: "js_validate.number",
    defaultMessage: "Please enter a valid number.",
  },
  password: {
    id: "js_validate.password",
    defaultMessage: "Please enter a valid password.",
  },
  passwordMinLength: {
    id: "js_validate.password_min_length",
    defaultMessage: "Your password must be at least {0} characters long.",
  },
  passwordSame: {
    id: "js_validate.password_same",
    defaultMessage: "Your password must be different from your username.",
  },
  required: {
    id: "js_validate.required",
    defaultMessage: "This field is required.",
  },
});
